import { createTheme } from '@mui/material/styles'
import { zhCN } from '@mui/material/locale'

declare module '@mui/material/styles' {
  interface Palette {
    neutral?: Palette['primary']
  }

  // allow configuration using `createTheme`
  interface PaletteOptions {
    neutral?: PaletteOptions['primary']
  }
}
declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    neutral?: true
  }
}

const theme = createTheme(
  {
    palette: {
      mode: 'light',
      primary: {
        main: '#206CFF',
      },
      error: {
        main: '#F64E54',
      },
      success: {
        main: '#52C41A',
      },
      warning: {
        main: '#FFBF00',
      },
      neutral: {
        main: '#fff',
        contrastText: 'rgba(0, 0, 0, 0.50)',
      },
    },

    components: {
      // MuiAlert: {
      //   styleOverrides: {
      //     root: ({ ownerState }) => ({
      //       ...(ownerState.severity === "info" && {
      //         backgroundColor: "#60a5fa",
      //       }),
      //     }),
      //   },
      // },

      MuiInputLabel: {
        styleOverrides: {
          root: {
            color: 'rgba(0, 0, 0, 0.20)',
          },
          asterisk: {
            color: '#F64E54',
          },
        },
      },
      MuiInputBase: {
        styleOverrides: {
          root: {
            '&.MuiInput-root::before': {
              borderColor: 'rgba(0, 0, 0, 0.13) ',
            },
            '&.MuiInput-root:hover::before': {
              borderColor: '#206CFF !important',
            },
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: '#206CFF',
            },
            '.MuiOutlinedInput-notchedOutline': {
              borderColor: 'rgba(0, 0, 0, 0.13)',
            },
          },
        },
      },
      MuiMenuItem: {
        styleOverrides: {
          root: {
            fontSize: '14px',
          },
        },
      },
      MuiCheckbox: {
        styleOverrides: {
          root: {
            color: 'rgba(0, 0, 0, 0.13)',
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            fontWeight: 400,
          },
        },
      },
    },
  },
  zhCN,
)

export default theme
